module.exports = __webpack_public_path__ + "static/media/box.3a32c684.png";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Panels/ExplorePanel/box.png
// module id = 741
// module chunks = 0